import { Typography } from "@mui/material"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useAppSelector } from "hooks/store"
import { useTranslation } from "react-i18next"
import { selectDisplayMode } from "store/displayMode/displayMode.selectors"
import { visuallyHiddenSx } from "styles/common/typography"

import GridView from "./gridView"
import ListingView from "./listingView"
import TableView from "./tableView"

const ClassStudentsTeacher = () => {
  const { t } = useTranslation()
  const isTablet = useIsBreakpointUp("tablet")
  const displayMode = useAppSelector(selectDisplayMode)

  const view =
    displayMode === "grid" ? (
      <GridView />
    ) : isTablet ? (
      <TableView />
    ) : (
      <ListingView />
    )

  return (
    <>
      <Typography variant="h1" sx={visuallyHiddenSx}>
        {t("layout.students")}
      </Typography>
      {view}
    </>
  )
}

export default ClassStudentsTeacher
